module.exports = __webpack_public_path__ + "images/greco-d5e4907a4bc0645d9e39d6e969a730b6.jpg";